export const GENERAL_BAD_REQUEST = 400;

export const NOT_FOUND_BAD_REQUEST = 404;

export const HTTP_CODES = {
	BAD_REQUEST: {
		GENERAL: 400,
		NOT_FOUND: 404,
	},
} as const;
